import { IconButton, Menu, MenuItem } from "@mui/material";
import { useAuth } from "@ssf/auth-components";
import type { Room } from "@ssf/play-common";
import { DotsVertical } from "mdi-material-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { generatePath } from "../lib/routes.js";

export const AdminMenu = ({
  roomKey,
  room,
}: {
  roomKey: string;
  room?: Room;
}) => {
  const { isFedAdmin } = useAuth();
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();
  const { t } = useTranslation("AdminMenu");

  if (!isFedAdmin) {
    return null;
  }

  return (
    <>
      <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
        <DotsVertical />
      </IconButton>
      <Menu
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(undefined)}
        onClick={() => setAnchorEl(undefined)}
      >
        {room && (
          <MenuItem
            component={Link}
            to={generatePath("settings", { room: roomKey })}
          >
            {t("manageRoom", { context: room?.type })}
          </MenuItem>
        )}
        <MenuItem component={Link} to={generatePath("tournaments", {})}>
          {t("tournaments")}
        </MenuItem>
        <MenuItem component={Link} to={generatePath("createTournament", {})}>
          {t("createTournament")}
        </MenuItem>
      </Menu>
    </>
  );
};
